import { ArrowUpRight } from 'lucide-react'
import { profile, socials } from '@/data/site'
import { socialIcon } from '@/components/ui/icons'

// Real routes (static, prerendered SEO pages) — crawlable full-page links
const pageLinks = [
  { name: 'About Keerthika', url: '/about/' },
  { name: 'Publications', url: '/publications/' },
  { name: 'Projects', url: '/projects/' },
  { name: 'Contact', url: '/contact/' },
]

export function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="relative border-t border-white/[0.06]">
      <div className="container py-16">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <p className="font-serif text-3xl italic text-white">{profile.name}</p>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-zinc-400">
              {profile.role} based in {profile.location}. Researching computer vision, NLP and machine learning
              for science.
            </p>
            <a href={`mailto:${profile.email}`} className="link-underline mt-5 text-sm">
              {profile.email}
            </a>
          </div>

          <nav aria-label="Site pages">
            <p className="eyebrow mb-4">Pages</p>
            <ul className="space-y-2.5">
              {pageLinks.map((l) => (
                <li key={l.url}>
                  <a href={l.url} className="text-sm text-zinc-400 transition-colors hover:text-white">
                    {l.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <p className="eyebrow mb-4">Elsewhere</p>
            <ul className="space-y-2.5">
              {socials.map((s) => {
                const Icon = socialIcon[s.name]
                return (
                  <li key={s.name}>
                    <a
                      href={s.url}
                      target="_blank"
                      rel="me noopener noreferrer"
                      className="group inline-flex items-center gap-2 text-sm text-zinc-400 transition-colors hover:text-white"
                    >
                      <Icon className="h-3.5 w-3.5" />
                      {s.name}
                      <ArrowUpRight className="h-3 w-3 opacity-0 transition-opacity group-hover:opacity-100" />
                    </a>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/[0.06] pt-6 text-xs text-zinc-500 sm:flex-row sm:items-center">
          <p>
            © {year} {profile.name}. All rights reserved.
          </p>
          <p className="font-mono">Built with curiosity in Chennai.</p>
        </div>
      </div>
    </footer>
  )
}
